// src/views/ViewStockReturnMain.js  (or wherever your file is)
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Breadcrumb from "../components/Breadcrumb";
import logo from "../assets/images/deviops_logo.png";
import stockReturnService from "../services/stockReturnService";
import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService"; // if you have this, otherwise remove employeeId part
import Loading from "../components/loading";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import UnAuthorized from "../views/Unathorized";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";

export default function ViewStockReturnMain() {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [header, setHeader] = useState(null);
  const [projectList, setProjectList] = useState([]);


  const companyId = StorageService.activeCompany().companyId;
  const employeeId = StorageService.loginData().employeeId;
  const roleId = StorageService.loginData().roleId;
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);


  // Modal states (like reference)
  const [showDetails, setShowDetails] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [detailRows, setDetailRows] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);

  // APPROVE
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveItem, setApproveItem] = useState(null);
  const [approveNote, setApproveNote] = useState("");

  // REJECT
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectItem, setRejectItem] = useState(null);
  const [rejectNote, setRejectNote] = useState("");

  // CANCEL
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelItem, setCancelItem] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [allReturns, setAllReturns] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const itemsPerPage = 10;


  useEffect(() => {

    const delayDebounce = setTimeout(() => {

      setCurrentPage(1);
      setSearch(searchText);

    }, 400);

    return () => clearTimeout(delayDebounce);

  }, [searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);



  const navigate = useNavigate();
  const printRef = useRef();

  const companyName = StorageService.activeCompany()?.companyName || "";

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "",
    pageStyle: `
      @page {
        size: auto;
        margin: 0mm;
      }
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
      }
    `
  });

  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => setMessage(""), 4000);
  // };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const { permission, can } = usePermission(
    ScreenData.Stock_Return,
    showMessage
  );

  // Optional: if you use employeeId/companyId like in reference
  // const employeeId = StorageService.loginData()?.employeeId;

  // useEffect(() => {
  //   fetchReturns();
  // }, [companyId]);

  // const fetchReturns = async () => {
  //   try {
  //     setLoading(true);

  //     const res = await stockReturnService.getAll(companyId);
  //     const rows = res?.data || [];

  //     setReturns(rows);
  //     setSelectedId(null);
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Failed to load stock returns");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  useEffect(() => {

    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }

    let mounted = true;

    setLoading(true);

    if (!companyId || !employeeId) {
      console.warn("Missing companyId or employeeId", {
        companyId,
        employeeId
      });

      setLoading(false);
      return;
    }

    stockReturnService.getAll(
      companyId,
      employeeId,
      roleId,
      1,
      1000,
      search,
      statusFilter
    )

      .then((res) => {

        if (!mounted) return;

        console.log("API RESPONSE:", res?.data);

        const rows = res?.data?.data || [];

        rows.sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
        );

        setAllReturns(rows);

        const totalPages = Math.max(1, Math.ceil(rows.length / itemsPerPage));
        setPageCount(totalPages);
        const safePage = Math.min(currentPage, totalPages);
        if (safePage !== currentPage) {
          setCurrentPage(safePage);
        }
        const start = (safePage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setReturns(rows.slice(start, end));

        setSelectedId(null);

      })

      .catch((err) => {

        console.error("GET ALL ERROR:", err);

        showMessage("Failed to load stock returns");

      })

      .finally(() => {

        if (mounted) setLoading(false);

      });

    return () => {

      mounted = false;

    };

  }, [
    companyId,
    employeeId,
    roleId,
    currentPage,
    permission,
    search,
    statusFilter
  ]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setReturns(allReturns.slice(start, end));
  }, [allReturns, currentPage]);




  const submitApprove = async () => {

    if (!approveNote.trim()) {
      showMessage("Please enter approval note");
      return;
    }

    try {

      await stockReturnService.approve(approveItem.id, {
        approvedBy: employeeId,
        approvedNotes: approveNote
      });

      setReturns(prev =>
        prev.map(r =>
          r.id === approveItem.id ? { ...r, status: "approved" } : r
        )
      );

      showMessage("Stock Return approved successfully", "success");
      setShowApproveModal(false);

    } catch (err) {
      console.error(err);
      showMessage(err.response?.data?.message || "Approval failed");
    }
  };


  const submitReject = async () => {

    if (!rejectNote.trim()) {
      showMessage("Please enter rejection note");
      return;
    }

    try {

      await stockReturnService.reject(rejectItem.id, {
        rejectedBy: employeeId,
        rejectedNotes: rejectNote
      });

      setReturns(prev =>
        prev.map(r =>
          r.id === rejectItem.id ? { ...r, status: "rejected" } : r
        )
      );

      showMessage("Stock Return rejected successfully", "success");
      setShowRejectModal(false);

    } catch (err) {
      console.error(err);
      showMessage(err.response?.data?.message || "Rejection failed");
    }
  };


  const handleModify = () => {

    if (!selectedId) {
      return showMessage("Please select one record to modify.");
    }

    const selectedRecord = returns.find(r => r.id === selectedId);

    if (!selectedRecord) {
      return showMessage("Selected record not found.");
    }

    if (selectedRecord.status !== "pending") {
      return showMessage("Only PENDING records can be modified.");
    }

    navigate(`/cpnl/StockReturn/add?id=${selectedId}`);
  };

  const submitCancel = async () => {

    try {

      await stockReturnService.cancel(cancelItem.id, {
        cancelledBy: employeeId
      });

      setReturns(prev =>
        prev.map(r =>
          r.id === cancelItem.id ? { ...r, status: "cancelled" } : r
        )
      );

      showMessage("Stock Return cancelled successfully", "success");
      setShowCancelModal(false);

    } catch (err) {
      console.error(err);
      showMessage(err.response?.data?.message || "Cancel failed");
    }
  };



  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  // const handleSelect = (id) => {
  //   setSelected((prev) =>
  //     prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
  //   );
  // };

  // const handleSelectAll = (e) => {
  //   setSelected(e.target.checked ? returns.map((r) => r.id) : []);
  // };

  const handleAdd = () => navigate("/cpnl/StockReturn/add");

  const handleView = () => {
    if (!selectedId) {
      return showMessage("Please select one record to view.");
    }

    setShowDetails(true);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const pRes = await ProjectService.getActive(companyId);
        const pData = pRes?.data || pRes || [];
        setProjectList(Array.isArray(pData) ? pData : []);
      } catch (e) {
        console.error("Failed to load projects:", e);
      }
    };
    if (companyId) {
      fetchProjects();
    }
  }, [companyId]);

  const formatEmployee = (name, code) => {
    if (name && code) return `${name} (${code})`;
    return name || code || "-";
  };

  const formatProjectDisplay = (project) => {
    if (!project) return "-";
    let projObj = project;
    if (typeof project === "string" || typeof project === "number") {
      const match =
        projectList.find(
          (p) =>
            String(p.id) === String(project) ||
            String(p.projectId) === String(project) ||
            p.projectName === project
        ) || {};
      projObj = Object.keys(match).length ? match : { projectName: String(project) };
    }

    const projectId = projObj.projectId || projObj.id;
    const matchedProject =
      (projectId &&
        projectList.find(
          (p) => String(p.id) === String(projectId) || String(p.projectId) === String(projectId)
        )) ||
      (projObj.projectName &&
        projectList.find((p) => p.projectName === projObj.projectName)) ||
      {};

    const projectName =
      projObj.projectName || projObj.name || matchedProject.projectName || "";
    const categoryName =
      projObj.projectCategoryName ||
      projObj.categoryName ||
      projObj.category ||
      matchedProject.projectCategoryName ||
      matchedProject.categoryName ||
      matchedProject.category ||
      "";
    const projectCode =
      projObj.projectCode || matchedProject.projectCode || "";
    const categoryInitial = String(categoryName).trim().charAt(0).toUpperCase();

    if (projectName) {
      if (categoryInitial) {
        return `${categoryInitial}*${projectName}`;
      }
      if (projectCode) {
        const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${projectName}`;
      }
      return projectName;
    }
    if (projectCode) {
      const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
      return `${codeInitial}*`;
    }
    return categoryInitial ? `${categoryInitial}*` : "-";
  };

  // Load details when modal opens
  useEffect(() => {
    if (!showDetails || !selectedId) return;

    const loadDetails = async () => {
      try {
        setDetailsLoading(true);
        const res = await stockReturnService.getById(selectedId);
        console.log("VIEW API:", res);

        const payload = res?.data?.data || res?.data || res || {};
        const selectedRecord =
          returns.find((r) => r.id === selectedId) ||
          allReturns.find((r) => r.id === selectedId) ||
          {};
        const mergedHeader = {
          ...selectedRecord,
          ...payload,
          projectName: payload.projectName || selectedRecord.projectName || "",
          projectCode: payload.projectCode || selectedRecord.projectCode || "",
          projectCategoryName:
            payload.projectCategoryName ||
            selectedRecord.projectCategoryName ||
            "",
          projectCategoryCode:
            payload.projectCategoryCode ||
            selectedRecord.projectCategoryCode ||
            "",
          stockReturnNotes:
            payload.stockReturnNotes ||
            selectedRecord.stockReturnNotes ||
            "",
        };

        const details =
          payload.details ||
          payload.stockReturnDetails ||
          selectedRecord.stockReturnDetails ||
          [];
        setHeader(mergedHeader);
        setDetailRows(details);
      } catch (err) {
        console.error("Failed to load details:", err);
        setDetailRows([]);
        showMessage("Failed to load item details");
      } finally {
        setDetailsLoading(false);
      }
    };

    loadDetails();
  }, [showDetails, selectedId, returns, allReturns]);



  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Breadcrumb pageTitle="Stock Return" secondTitle="Inventory" />

      <div className="card p-3 bg-white shadow-sm">
        {/* {message && (
          <div
            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center mb-3`}
          >
            <span>{message}</span>
            <button className="btn-close" onClick={closeMessage}></button>
          </div>
        )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />

        <div className="mb-3 pb-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
          {can("canAdd") && (
            <button className="btn btn-success me-2" onClick={handleAdd}>
              + Add
            </button>
          )}

          {can("canModify") && (
            <button className="btn btn-warning me-2" onClick={handleModify}>
              <i className="ti ti-edit me-1"></i> Modify
            </button>
          )}

          {can("canView") && (
            <>
              <button className="btn btn-primary me-2" onClick={handleView}>
                <i className="ti ti-eye me-1"></i> View
              </button>

              <select
                className="form-select d-inline w-auto"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </>
          )}

          <div className="d-flex align-items-center ms-auto">
            <div className="position-relative">

              <input
                type="text"
                className="form-control pe-5"
                placeholder="Search Project / Voucher No"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: "280px" }}
              />

              <i
                className="ti ti-search position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d"
                }}
              ></i>

            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Select</th>
                <th>Return Voucher No</th>
                <th>Outward Voucher No</th>
                <th>Return Date</th>
                <th>Project</th>
                <th>To Store</th>
                <th>Return Type</th>
                {/* <th>Return Date</th> */}
                <th>Notes</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <Loading />
                  </td>
                </tr>
              ) : returns.length > 0 ? (
                returns.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <input
                        type="radio"
                        name="stockReturnSelect"
                        checked={selectedId === r.id}
                        onChange={() => setSelectedId(r.id)}
                      />
                    </td>
                    <td>{r.vocherNo || "-"}</td>
                    <td>
                      {(() => {
                        const uniqueVouchers = Array.from(
                          new Set(
                            (r.stockReturnDetails || [])
                              .map((d) => d.stockOutVoucherNo)
                              .filter(Boolean)
                          )
                        );
                        return uniqueVouchers.length > 0 ? (
                          uniqueVouchers.map((v, index) => (
                            <div key={index} style={{ marginBottom: "2px" }}>
                              {v}
                            </div>
                          ))
                        ) : (
                          "-"
                        );
                      })()}
                    </td>
                    <td>{utility.formatDateDDMMMYYYY(r.returnDate)}</td>
                    <td>{r.projectName || "-"}-{r.projectCode || "-"}</td>
                    <td>{r.storeName || "-"}</td>
                    <td>{r.returnType || "-"}</td>
                    {/* <td>{utility.formatDateDDMMMYYYY(r.returnDate)}</td> */}
                    <td>{r.stockReturnNotes || "-"}</td>
                    <td>
                      <span
                        className={`badge ${r.status === "pending"
                          ? "bg-info text-dark"
                          : r.status === "approved"
                            ? "bg-success"
                            : r.status === "rejected"
                              ? "bg-danger"
                              : r.status === "cancelled"
                                ? "bg-dark"
                                : "bg-secondary"
                          }`}
                      >
                        {r.status}
                      </span>
                    </td>

                    <td className="text-center d-flex justify-content-center gap-2">

                      {can("canApprove") && (
                        <button
                          className="btn btn-success btn-sm"
                          title="Approve"
                          disabled={r.status !== "pending"}
                          onClick={() => {
                            setApproveItem(r);
                            setApproveNote("");
                            setShowApproveModal(true);
                          }}
                        >
                          <i className="ti ti-circle-check"></i>
                        </button>
                      )}

                      {can("canReject") && (
                        <button
                          className="btn btn-danger btn-sm"
                          title="Reject"
                          disabled={r.status !== "pending"}
                          onClick={() => {
                            setRejectItem(r);
                            setRejectNote("");
                            setShowRejectModal(true);
                          }}
                        >
                          <i className="ti ti-circle-x"></i>
                        </button>
                      )}

                      {can("canCancel") && (
                        <button
                          className="btn btn-secondary btn-sm"
                          title="Cancel"
                          disabled={r.status !== "pending" || Number(r.createdBy) !== Number(employeeId)}
                          onClick={() => {
                            setCancelItem(r);
                            setShowCancelModal(true);
                          }}
                        >
                          <i className="ti ti-cancel"></i>
                        </button>
                      )}

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No Stock Returns Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <ReactPaginate
            forcePage={Math.max(0, Math.min(currentPage - 1, Math.max(pageCount - 1, 0)))}
            onPageChange={(e) => setCurrentPage(e.selected + 1)}
            pageCount={Math.max(1, pageCount)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            previousLabel="< Previous"
            nextLabel="Next >"
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            nextClassName="page-item"
            activeClassName="active"
          />
        </div>
      </div>

      {/* DETAILS MODAL - Like Reference File */}
      {showDetails && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Stock Return Item Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowDetails(false);
                    setSelectedId(null);
                    setDetailRows([]);
                  }}
                ></button>
              </div>

              {/* <div className="modal-body">
                {detailsLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : (

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>UOM</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailRows.length > 0 ? (
                        detailRows.map((r, i) => (
                          <tr key={i}>
                            <td>{r.itemName}-{r.itemCode}</td>
                            <td>{r.UOM}</td>
                            <td>{r.quantity}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div> */}


              <div className="modal-body">
                {detailsLoading ? (
                  <div className="text-center py-4">
                    <Loading />
                  </div>
                ) : (
                  <>
                    {header && (
                      <div className="row mb-3">
                        {/* <div className="col-md-4">
                          <strong>Voucher No:</strong> {header.vocherNo || "-"}
                        </div>
                        <div className="col-md-4 text-end">
                          <strong>Return Date:</strong> {utility.formatDateDDMMMYYYY(header.returnDate)}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Project:</strong> {header.projectName || "-"}
                        </div>
                        <div className="col-md-6 mt-2">
                          <strong>Store:</strong> {header.storeName || "-"}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Return Type:</strong> {header.returnType || "-"}
                        </div> */}

                        <div className="row mb-3">

                          {/* Row 1 */}
                          <div className="col-md-6">
                            <strong>Project Name:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{formatProjectDisplay(header)}</span>
                          </div>
                          <div className="col-md-6">
                            <strong>Return Date:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{utility.formatDateDDMMMYYYY(header.returnDate)}</span>
                          </div>

                          {/* Row 2 */}
                          <div className="col-md-6 mt-2">
                            <strong>To Store:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.storeName || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>From Location:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.locationName || "-"}</span>
                          </div>

                          {/* Row 3 */}
                          <div className="col-md-6 mt-2">
                            <strong>Return Type:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.returnType || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Outward Voucher No:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{Array.from(new Set(detailRows.map(dr => dr.stockOutVoucherNo).filter(Boolean))).join(", ") || "-"}</span>
                          </div>

                          {/* Row 4 */}
                          <div className="col-md-6 mt-2">
                            <strong>Return Voucher No:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.vocherNo || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Created By:</strong> {formatEmployee(header.createdByName, header.createdByCode)}
                          </div>

                          {/* Row 5 - Status & Notes */}
                          <div className="col-md-6 mt-2">
                            <strong>Status:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.status ? header.status.toUpperCase() : "PENDING"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Notes:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.stockReturnNotes || "-"}</span>
                          </div>

                          {/* Conditional Action Notes */}
                          {header.status?.toLowerCase() === "approved" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Approved By:</strong> {formatEmployee(header.approvedByName, header.approvedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Approved Notes:</strong> {header.approvedNotes || "-"}
                              </div>
                            </>
                          )}

                          {header.status?.toLowerCase() === "rejected" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected By:</strong> {formatEmployee(header.rejectedByName, header.rejectedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected Notes:</strong> {header.rejectedNotes || "-"}
                              </div>
                            </>
                          )}

                          {header.status?.toLowerCase() === "cancelled" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled By:</strong> {formatEmployee(header.cancelledByName, header.cancelledByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled Notes:</strong> {header.cancelledNotes || "-"}
                              </div>
                            </>
                          )}

                        </div>
                      </div>
                    )}

                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Voucher No</th>
                            <th>To Store</th>
                            <th>Item Category</th>
                            <th>Item</th>
                            <th>UOM</th>
                            <th>Issued Qty</th>
                            <th>Return Quantity</th>
                            <th>Damaged Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailRows.length > 0 ? (
                            detailRows.map((r, i) => (
                              <tr key={i}>
                                <td>{r.stockOutVoucherNo || "-"}</td>
                                <td>{r.toStoreName || "-"}</td>
                                <td>{r.itemCategoryName || "-"}</td>
                                <td>{r.itemName && r.itemCode ? `${r.itemName} - ${r.itemCode}` : (r.itemName || r.itemCode || "-")}</td>
                                <td>{r.UOM}</td>
                                <td>{Number(r.issuedQty || 0).toFixed(3)}</td>
                                <td>{Number(r.quantity || 0).toFixed(3)}</td>
                                <td>{Number(r.damagedQty || 0).toFixed(3)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No Records Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* PRINT TEMPLATE */}
                    <div style={{ display: "none" }}>
                      <div ref={printRef} className="print-container">

                        <div className="print-top-header">
                          <div className="print-top-left">
                            <img src={logo} alt="Logo" className="print-logo" />
                            <span className="print-company">{companyName}</span>
                          </div>
                          <div className="print-top-right">
                            <b>Printed Date:</b> {utility.formatExportDateTime(new Date())}
                          </div>
                        </div>

                        <h3 className="print-title">Material Return Slip</h3>

                        <table className="print-header">
                          <tbody>

                            <tr className="project-store-row">
                              <td><b>Project Name:</b> {formatProjectDisplay(header)}</td>
                              <td><b>To Store:</b> {header?.storeName || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>From Location:</b> {header?.locationName || "-"}</td>
                              <td><b>Return Voucher No:</b> {header?.vocherNo || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Outward Voucher No:</b> {Array.from(new Set(detailRows.map(dr => dr.stockOutVoucherNo).filter(Boolean))).join(", ") || "-"}</td>
                              <td><b>Stock Out Date:</b> {utility.formatDateDDMMMYYYY(header?.stockOutDate || detailRows.find(dr => dr.stockOutDate)?.stockOutDate) || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Return Date:</b> {utility.formatDateDDMMMYYYY(header?.returnDate)}</td>
                              <td><b>Transporter:</b> {header?.transporterName || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Return Type:</b> {header?.returnType || "-"}</td>
                              <td><b>Status:</b> {header?.status ? header.status.toUpperCase() : "PENDING"}</td>
                            </tr>

                            <tr>
                              <td><b>Created By:</b> {formatEmployee(header?.createdByName, header?.createdByCode)}</td>
                              <td><b>Notes:</b> {header?.stockReturnNotes || "-"}</td>
                            </tr>

                            {header?.status?.toLowerCase() === "approved" && (
                              <tr>
                                <td><b>Approved By:</b> {formatEmployee(header?.approvedByName, header?.approvedByCode)}</td>
                                <td><b>Approved Notes:</b> {header?.approvedNotes || "-"}</td>
                              </tr>
                            )}

                            {header?.status?.toLowerCase() === "rejected" && (
                              <tr>
                                <td><b>Rejected By:</b> {formatEmployee(header?.rejectedByName, header?.rejectedByCode)}</td>
                                <td><b>Rejected Notes:</b> {header?.rejectedNotes || "-"}</td>
                              </tr>
                            )}

                            {header?.status?.toLowerCase() === "cancelled" && (
                              <tr>
                                <td><b>Cancelled By:</b> {formatEmployee(header?.cancelledByName, header?.cancelledByCode)}</td>
                                <td><b>Cancelled Notes:</b> {header?.cancelledNotes || "-"}</td>
                              </tr>
                            )}

                          </tbody>
                        </table>

                        <table className="print-table">
                          <thead>
                            <tr>
                              <th style={{ width: "4%" }} className="text-center">S.No</th>
                              <th style={{ width: "16%" }} className="text-start">Voucher No</th>
                              <th style={{ width: "11%" }} className="text-start">To Store</th>
                              <th style={{ width: "16%" }} className="text-start">Item Category</th>
                              <th style={{ width: "15%" }} className="text-start">Item Code</th>
                              <th style={{ width: "5%" }} className="text-center">UOM</th>
                              <th style={{ width: "8%" }} className="text-end">Issued Qty</th>
                              <th style={{ width: "8%" }} className="text-end">Return Qty</th>
                              <th style={{ width: "8%" }} className="text-end">Damaged Qty</th>
                              <th style={{ width: "9%" }} className="text-start">Remarks</th>
                            </tr>
                          </thead>

                          <tbody>
                            {detailRows.map((d, i) => (
                              <tr key={i}>
                                <td className="text-center">{i + 1}</td>
                                <td className="text-start">{d.stockOutVoucherNo || "-"}</td>
                                <td className="text-start">{d.toStoreName || "-"}</td>
                                <td className="text-start">{d.itemCategoryName || "-"}</td>
                                <td className="text-start">{d.itemCode || "-"}</td>
                                <td className="text-center">{d.UOM || "-"}</td>
                                <td className="text-end">{Number(d.issuedQty || 0).toFixed(3)}</td>
                                <td className="text-end">{Number(d.quantity || 0).toFixed(3)}</td>
                                <td className="text-end">{Number(d.damagedQty || 0).toFixed(3)}</td>
                                <td className="text-start">{d.remarks || d.notes || ""}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div style={{ marginTop: "60px", display: "flex", justifyContent: "space-between", width: "100%" }}>
                          <div>Site Engg/Sup Signature</div>
                          <div>Store Incharge Signature</div>
                          <div>Approved By Signature</div>
                        </div>

                      </div>
                    </div>

                  </>
                )}
              </div>


              <div className="modal-footer">

                <button
                  className="btn btn-success me-2"
                  onClick={handlePrint}
                >
                  <i className="ti ti-printer me-1"></i>
                  Print
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowDetails(false);
                    setSelectedId(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showApproveModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Approve Stock Return</h5>

            <div className="mb-2">
              <label>Approval Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Approval Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={approveNote}
                onChange={(e) => setApproveNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowApproveModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-success"
                onClick={submitApprove}
              >
                Approve
              </button>

            </div>
          </div>
        </div>
      )}

      {showRejectModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Reject Stock Return</h5>

            <div className="mb-2">
              <label>Rejection Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Rejection Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={rejectNote}
                onChange={(e) => setRejectNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowRejectModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-danger"
                onClick={submitReject}
              >
                Reject
              </button>

            </div>
          </div>
        </div>
      )}

      {showCancelModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "400px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Cancel Stock Return</h5>

            <p>Are you sure you want to cancel this record?</p>

            <div className="d-flex justify-content-end gap-2">

              <button
                className="btn btn-secondary"
                onClick={() => setShowCancelModal(false)}
              >
                No
              </button>

              <button
                className="btn btn-dark"
                onClick={submitCancel}
              >
                Yes Cancel
              </button>

            </div>
          </div>
        </div>
      )}
    </>
  );
}